import { render, staticRenderFns } from "./CustomerActivityDisplayCommentEdit.vue?vue&type=template&id=093755fb"
import script from "./CustomerActivityDisplayCommentEdit.vue?vue&type=script&lang=js"
export * from "./CustomerActivityDisplayCommentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports